module.exports = __webpack_public_path__ + "img/title-bg.234982c5.png";